import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../api';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!email || !email.includes('@')) {
      setError('Bitte gib eine gültige E-Mail-Adresse ein.');
      return;
    }

    setLoading(true);
    
    try {
      const data = await requestPasswordReset(email);
      
      if (data.success) {
        setSuccess(data.message);
        setEmail('');
      } else {
        setError(data.error || 'Fehler beim Senden der E-Mail.');
      }
    } catch (err) {
      setError('Netzwerkfehler. Bitte versuche es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      maxWidth: 400, 
      margin: '60px auto', 
      background: 'white', 
      borderRadius: 8, 
      boxShadow: '0 2px 12px rgba(0,0,0,0.1)', 
      padding: 32 
    }}>
      <h2 style={{ color: '#4a6de5', marginBottom: 24, textAlign: 'center' }}>
        Passwort vergessen
      </h2>
      
      <p style={{ 
        color: '#666', 
        marginBottom: 24, 
        textAlign: 'center',
        lineHeight: 1.5 
      }}>
        Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.
      </p>

      {error && (
        <div style={{ 
          color: '#e53e3e', 
          backgroundColor: '#fed7d7', 
          padding: 12, 
          borderRadius: 4, 
          marginBottom: 16,
          fontSize: 14 
        }}>
          {error}
        </div>
      )}

      {success && (
        <div style={{ 
          color: '#38a169', 
          backgroundColor: '#c6f6d5', 
          padding: 12, 
          borderRadius: 4, 
          marginBottom: 16,
          fontSize: 14 
        }}>
          {success}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ 
            display: 'block', 
            marginBottom: 8, 
            fontWeight: 500,
            color: '#4a5568' 
          }}>
            E-Mail-Adresse
          </label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{ 
              width: '100%', 
              padding: 12, 
              borderRadius: 4, 
              border: '1px solid #e2e8f0',
              fontSize: 16,
              boxSizing: 'border-box'
            }}
            placeholder="deine@email.de"
            required
            disabled={loading}
          />
        </div>
        
        <button
          type="submit"
          disabled={loading}
          style={{ 
            width: '100%', 
            background: '#4a6de5', 
            color: 'white', 
            padding: 12, 
            border: 'none', 
            borderRadius: 4, 
            fontWeight: 600, 
            fontSize: 16, 
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
            marginBottom: 16
          }}
        >
          {loading ? 'Sende E-Mail...' : 'Reset-Link senden'}
        </button>
      </form>

      <div style={{ 
        textAlign: 'center', 
        marginTop: 24,
        paddingTop: 16,
        borderTop: '1px solid #e2e8f0' 
      }}>
        <button
          onClick={() => navigate('/')}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#4a6de5', 
            cursor: 'pointer',
            fontSize: 14,
            textDecoration: 'underline' 
          }}
        >
          Zurück zum Login
        </button>
      </div>
    </div>
  );
}

export default ForgotPassword; 